import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Title } from 'components/Title/Title';
import { Tools } from 'components/Tools/Tools';
import { Navigation } from 'components/Navigation/Navigation';
import { useTypedSelector } from 'redux/reducers';
import { useViewport } from 'hooks/useViewport';
import { theme } from 'theme';
import czoLogo from 'assets/images/czo-logo.png';
import { Drawing } from 'components/Drawing/Drawing';
import { ITopic } from 'config/topics';

export interface ITopicHover {
  hoveredTopic: ITopic | undefined; 
  setHoveredTopic: React.Dispatch<React.SetStateAction<ITopic | undefined>>;
}

const StyledFrame = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  background: linear-gradient(180deg, #E1EDF8 0%, #D3E7DD 40%);
  border-radius: ${({ theme }) => `${theme.radius.sm}`};
`;

const StyledFrameTop = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  position: absolute; 
  transform: translateY(-50%);
  z-index: 10;
  padding: ${({ theme }) => `0 ${theme.spacing[3]}`};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledLogo = styled.img`
  width: ${({ theme }) => theme.spacing[8]};
`;

const Frame: React.FC = () => {
  const { width } = useViewport();
  const { label, image } = useTypedSelector((state) => state.topic.selected);
  const [hoveredTopic, setHoveredTopic] = useState<ITopic>();

  return (
    <StyledFrame>
      {width >= theme.breakpoints.lg && (
        <React.Fragment>
          <StyledFrameTop>
            <StyledLogo src={czoLogo} />
            <Title label={label || 'CZO Interactive'} />
            <Tools orientation="horizontal" />
          </StyledFrameTop>
          <Navigation hoveredTopic={hoveredTopic} setHoveredTopic={setHoveredTopic} />
        </React.Fragment>
      )}
      <Drawing src={image} hoveredTopic={hoveredTopic} setHoveredTopic={setHoveredTopic} />
    </StyledFrame >
  );
};

export { Frame };
